import {useAuthState} from "react-firebase-hooks/auth";
import {auth} from "../firebase";

export function withAuth(Component) {
    return function WrappedComponent(props) {
        const myHookValue = useAuthState(auth);
        return <Component {...props} authState={myHookValue} />;
    }
}
